import * as React from "react";

function SvgClicky(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 132 132.273"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <circle fill="#FFF" cx={66.136} cy={66.137} r={62.228} />
      <path
        fill="#F19330"
        d="M66.136 0C29.611 0 0 29.611 0 66.138c0 36.524 29.611 66.135 66.136 66.135 36.526 0 66.137-29.609 66.137-66.135C132.273 29.611 102.662 0 66.136 0zm0 127.748c-34.025 0-61.61-27.584-61.61-61.608 0-34.027 27.584-61.611 61.61-61.611 34.026 0 61.61 27.584 61.61 61.611.001 34.024-27.584 61.608-61.61 61.608z"
      />
      <path
        fill="#FFF"
        d="M83.281 89.084L70.462 66.217a.656.656 0 01.302-.929l11.265-5.185c.36-.166.377-.47.038-.673L51.626 41.093c-.339-.203-.61-.048-.601.35l.767 35.13c.009.396.282.535.606.308l9.433-6.565a.64.64 0 01.943.215l12.819 22.867c.194.345.635.47.98.273l6.433-3.604a.726.726 0 00.275-.983z"
      />
      <path
        fill="#F29B40"
        d="M93.847 60.666L46.24 31.723c-.338-.206-.614-.052-.613.346l.206 55.515c.001.396.257.521.567.273l13.252-10.475a.597.597 0 01.917.184l13.216 23.574a.72.72 0 00.98.273l15.791-8.853a.724.724 0 00.276-.98L77.616 68.01a.597.597 0 01.323-.877l15.848-5.844c.371-.137.399-.417.06-.623zm-11.818-.562l-11.265 5.185a.656.656 0 00-.302.929l12.819 22.867a.72.72 0 01-.276.979l-6.433 3.604a.723.723 0 01-.98-.274L62.773 70.529a.642.642 0 00-.943-.216l-9.433 6.565c-.325.229-.598.088-.606-.309l-.767-35.129c-.009-.396.262-.553.601-.35l30.441 18.34c.34.205.323.508-.037.674z"
      />
      <path
        fill="#F9C692"
        d="M116.431 49.938s-3.93-2.551-3.875-2.417c0 0-19.892-13.066-53.655 20.896l-.017.02C46.819 55.713 40.834 49.585 33.58 50.934c-8.686 1.615-17.477 12.26-17.477 12.26.031-.468-2.921 2.792-2.921 3.314 0 29.245 23.708 52.955 52.954 52.955 29.246 0 52.955-23.709 52.955-52.955 0-5.789-.943-11.356-2.66-16.57z"
      />
      <path
        fill="#F8BE83"
        d="M66.136 11.932c-29.936 0-54.204 24.268-54.204 54.206 0 29.936 24.268 54.203 54.204 54.203s54.205-24.269 54.205-54.203c0-29.938-24.269-54.206-54.205-54.206zm0 2.88c21.441 0 39.79 13.154 47.468 31.83-3.164-1.688-22.879-10.117-54.461 21.652l-.017.02C46.775 55.291 40.649 49.017 33.223 50.398c-8.891 1.653-17.889 12.549-17.889 12.549.013-.204.053-.399.069-.604l-.43.604c1.654-26.853 23.894-48.135 51.163-48.135zm0 102.651c-27.417 0-49.747-21.515-51.186-48.57 5.929-8.411 11.239-14.219 19.199-15.519 6.892-1.125 12.682 5.959 25.382 19.735a.387.387 0 01.017-.021c32.727-35.629 51.964-24.631 55.691-21.886a51.29 51.29 0 012.223 14.934c-.001 28.348-22.98 51.327-51.326 51.327z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgClicky);
